import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { contentHubResourcesQueryOptions } from "src/components/contentHubQueries";
import { CoachLibraryResourcesPage } from "src/pages/CoachLibraryResourcesPage";

const searchSchema = z.object({
  editResourceId: z.string().optional(),
});

export const Route = createFileRoute("/_auth/_coach/library/resources/")({
  component: RouteComponent,
  validateSearch: searchSchema,
  ssr: true,
  shouldReload: false,
  async loader({ context }) {
    await context.queryClient.query({
      ...contentHubResourcesQueryOptions(),
      staleTime: "static",
    });
  },
  staticData: {
    getBreadcrumb() {
      return {
        label: "Resources",
        href: "/library/resources",
      };
    },
  },
});

function RouteComponent() {
  return <CoachLibraryResourcesPage />;
}
